import { render } from "./ReviewStatus.vue?vue&type=template&id=62683620"
import script from "./ReviewStatus.vue?vue&type=script&lang=js"
export * from "./ReviewStatus.vue?vue&type=script&lang=js"

import "./ReviewStatus.vue?vue&type=style&index=0&id=62683620&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pullrequests/ReviewStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62683620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62683620', __exports__)) {
    api.reload('62683620', __exports__)
  }
  
  module.hot.accept("./ReviewStatus.vue?vue&type=template&id=62683620", () => {
    api.rerender('62683620', render)
  })

}


export default __exports__